// This file was auto generated by resource-sync tools.

import ar_translation from './ar/translation.json';
import en_translation from './en/translation.json';
import ptBR_translation from './pt-BR/translation.json';
import ur_translation from './ur/translation.json';
import zh_translation from './zh/translation.json';
import zhHK_translation from './zh-HK/translation.json';

const resources = {
    'namespaces': [{
        'i18nConfig': {"env":"prod","apiKey":"cb1575a166f345489d543674572915f6","projectId":"3","namespaceId":"1dgatt6ujk","namespaceName":"translation"},
        'localeInfos': [{"locale":"ar","version":228},{"locale":"en","version":226},{"locale":"pt-BR","version":90},{"locale":"ur","version":1},{"locale":"zh","version":213},{"locale":"zh-HK","version":205}]
    }],
    'ar': {
        translation: ar_translation
    },
    'en': {
        translation: en_translation
    },
    'pt-BR': {
        translation: ptBR_translation
    },
    'ur': {
        translation: ur_translation
    },
    'zh': {
        translation: zh_translation
    },
    'zh-HK': {
        translation: zhHK_translation
    }
};

export default resources;